import React from 'react';
import { useRouteMatch, Switch, Redirect } from 'react-router-dom';
import AuthorizedRoute from 'routes/AuthorizedRoute';
import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';

import Create from './submodules/create';
import Edit from './submodules/edit';
import List from './submodules/list';

const FeatureSegmentsDashboard: React.FC<{}> = () => {
	const { path } = useRouteMatch();

	return (
		<Switch>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].getFeatureSegmentsList]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/list`}
				component={List}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateFeatureSegments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/edit`}
				component={Edit}
				exact
			/>
			<AuthorizedRoute
				entity={DASHBOARD_RESOURCES.userSegment}
				actions={[DASHBOARD_SCOPES[DASHBOARD_RESOURCES.userSegment].updateFeatureSegments]}
				configPageName={PAGE_NAMES.dashboard}
				path={`${path}/create`}
				component={Create}
				exact
			/>
			<Redirect to={`${path}/list`} />
		</Switch>
	);
};

export default FeatureSegmentsDashboard;
